import React from 'react';
import { Button } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/button.less';
import 'semantic-ui-less/definitions/elements/label.less';

const button = props => (
  (props.disabled) ?
    <span className="not-allowed"><Button {...props} /></span> :
    <Button {...props} />
);

button.displayName = 'Button';
button.propTypes = Button.propTypes;
button.defaultProps = Button.defaultProps;
button.Content = Button.Content;
button.Group = Button.Group;
button.Or = Button.Or;

export default button;
